import React from 'react';
import styles from './Table.module.css';

export interface TableColumn<TData> {
	key: string;
	header: React.ReactNode;
	renderCell: (item: TData, index: number) => React.ReactNode;
	headerClassName?: string;
	cellClassName?: string;
}

interface TableProps<TData> {
	data: TData[];
	columns: TableColumn<TData>[];
	getRowKey: (item: TData, index: number) => React.Key;
	rowClassName?: string;
	tableClassName?: string;
	containerClassName?: string;
	getRowProps?: (item: TData, index: number) => React.HTMLAttributes<HTMLTableRowElement> | undefined;
}

function mergeClassNames(...classNames: Array<string | undefined>): string {
	return classNames.filter(Boolean).join(' ');
}

export function Table<TData>({
	data,
	columns,
	getRowKey,
	rowClassName,
	tableClassName,
	containerClassName,
	getRowProps,
}: TableProps<TData>): React.ReactElement {
	return (
		<div className={mergeClassNames(styles.tableCard, containerClassName)}>
			<table className={mergeClassNames(styles.table, tableClassName)}>
				<thead>
					<tr>
						{columns.map((column) => (
							<th key={column.key} className={column.headerClassName}>
								{column.header}
							</th>
						))}
					</tr>
				</thead>
				<tbody>
					{data.map((item, index) => {
						const rowProps = getRowProps?.(item, index);

						return (
							<tr
								{...rowProps}
								key={getRowKey(item, index)}
								className={mergeClassNames(rowClassName, rowProps?.className)}
							>
								{columns.map((column) => (
									<td key={column.key} className={column.cellClassName}>
										{column.renderCell(item, index)}
									</td>
								))}
							</tr>
						);
					})}
				</tbody>
			</table>
		</div>
	);
}
